import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { authLoginAsync, authLogoutAsync } from '../../store/slices/voucherAuthSlice'
import { ReactComponent as AppLogoKr } from '../../resources/images/app_logo_kr.svg'
import { ReactComponent as AppLogoEn } from '../../resources/images/app_logo_en.svg'
import signupMethodKr from '../../resources/images/signup_method_kr.png'
import signupMethodEn from '../../resources/images/signup_method_en.png'
import useKeyPress from '../../hooks/useKeyPress'
import VoucherRegistrationModal from './VoucherRegistrationModal'
import { FormattedMessage, useIntl } from 'react-intl'
import { useLanguage } from '../../contexts/LanguageContext'

const LoginPage = () => {
  const intl = useIntl()
  const { language } = useLanguage()
  const voucherAuthReducer = useSelector((state) => state.voucherAuth)
  const [formData, setFormData] = useState({
    id: '',
    password: '',
  })
  const dispatch = useDispatch()
  const [showVoucherRegistrationModal, setShowVoucherRegistrationModal] = useState(false)

  const openVoucherRegistrationModal = () => {
    setShowVoucherRegistrationModal(true)
  }

  const closeVoucherRegistrationModal = () => {
    setShowVoucherRegistrationModal(false)
  }

  useEffect(() => {
    if (showVoucherRegistrationModal) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [showVoucherRegistrationModal])

  const closeThing = () => {
    setShowVoucherRegistrationModal(false)
  }

  useKeyPress(27, closeThing)

  const handleFormData = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const login = async (e) => {
    e.preventDefault()
    if (formData.id === '') {
      alert(intl.formatMessage({ id: 'alert.id.empty' }))
      return
    } else if (formData.password === '') {
      alert(intl.formatMessage({ id: 'alert.password.empty' }))
      return
    }
    const body = {
      id: formData.id,
      password: formData.password,
    }
    dispatch(authLoginAsync(body))
    setFormData({
      ...formData,
      password: '',
    })
  }

  const logout = async () => {
    const body = {
      accountId: voucherAuthReducer.account.accountId,
    }
    dispatch(authLogoutAsync(body))
  }

  return (
    <div>
      <VoucherRegistrationModal showVoucherRegistrationModal={showVoucherRegistrationModal}
                                closeVoucherRegistrationModal={closeVoucherRegistrationModal}
                                accountId={voucherAuthReducer.account ? voucherAuthReducer.account.accountId : '0'}/>
      <div className="flex justify-center items-center">
        {/*<div>*/}
        {/*  {voucherAuthSlice.loginStatus}<br/>*/}
        {/*</div>*/}
        <div className="mt-[160px]">
          <div className="flex justify-center items-center">
            {language === 'kr' ? 
              <AppLogoKr width="96" height="96" className="h-[72px] w-[72px] lg:h-auto lg:w-auto"/> :
              <AppLogoEn width="96" height="96" className="h-[72px] w-[72px] lg:h-auto lg:w-auto"/>
            }
          </div>
          <div className="flex justify-center">
            <div className="shadow bg-[#ffffff] rounded-[20px] w-[300px] mt-[40px] py-[14px] px-[20px] lg:w-[500px] lg:mt-[50px] lg:py-[20px] lg:px-[30px]">
              {voucherAuthReducer.loginStatus === 'LOGGED_IN' ? (
                <div>
                  <div>
                    <div>
                      <div><FormattedMessage id="app.id.label" /></div>
                      <div>
                        <div className="w-[100%] border border-[#d9dce1] rounded-md mt-[10px] p-[4px] lg:mt-[12px] lg:p-[10px]">
                          {voucherAuthReducer.account ? voucherAuthReducer.account.id : ''}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-[20px] lg:mt-[26px]">
                    <button className="font-[nanum-square-neo-e] w-[100%] bg-[#005ade] text-[#ffffff] rounded-md p-[4px] lg:p-[10px]"
                            type="button"
                            onClick={openVoucherRegistrationModal}>
                      <FormattedMessage id="voucher.registration" />
                    </button>
                  </div>
                  <div className="mt-[10px] lg:mt-[12px]">
                    <button className="font-[nanum-square-neo-e] w-[100%] bg-[#f3f4f6] rounded-md p-[4px] lg:p-[10px]" type="button" onClick={logout}>
                      <FormattedMessage id="logout.button" />
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <form onSubmit={(e) => login(e)}>
                    <div>
                      <div><FormattedMessage id="app.id.label" /></div>
                      <div>
                        <input className="w-[100%] border border-[#d9dce1] rounded-md mt-[10px] p-[4px] lg:mt-[12px] lg:p-[10px]"
                               type="text"
                               name="id"
                               placeholder={intl.formatMessage({ id: 'placeholder.id' })}
                               value={formData.id || ''}
                               onChange={handleFormData}/>
                      </div>
                    </div>
                    <div className="mt-[14px] lg:mt-[20px]">
                      <div><FormattedMessage id="password.label" /></div>
                      <div>
                        <input className="w-[100%] border border-[#d9dce1] rounded-md mt-[10px] p-[4px] lg:mt-[12px] lg:p-[10px]"
                               type="password"
                               name="password"
                               placeholder={intl.formatMessage({ id: 'placeholder.password' })}
                               value={formData.password || ''}
                               onChange={handleFormData}
                               autoComplete={'off'}/>
                      </div>
                    </div>
                    <div className="mt-[20px] lg:mt-[26px]">
                      <div>
                        <button className="font-[nanum-square-neo-e] w-[100%] bg-[#005ade] text-[#ffffff] rounded-md p-[4px] lg:p-[10px]" type="submit">
                          <FormattedMessage id="login.button" />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
          <div className="mt-[60px] mb-[120px] lg:mt-[80px] lg:mb-[160px]">
            <div className="w-[300px] lg:w-[500px]">
              <img src={language === 'kr' ? signupMethodKr : signupMethodEn} alt="signup_method"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
